<form (ngSubmit)="onSubmit()"
  *ngIf="!isMessageSent"
  [formGroup]="newsletterForm"
  class="px-3">

  <div class="row align-items-center">
    <div class="col-auto">
      <mat-form-field class="">
        <mat-label>{{ 'COMMON.LABEL.EMAIL' | translate }}</mat-label>
        <input matInput
          type="text"
          formControlName="email" />
      </mat-form-field>
    </div>
    <div class="col">
      <button mat-raised-button
        class="w-100"
        color="accent">{{ 'COMMON.LABEL.SUBSCRIBE_ME' | translate }}</button>
    </div>
  </div>

  <div class="row pb-2 mt-3 mt-sm-0">
    <div class="col-auto">
      <mat-checkbox class="w-100"
        formControlName="newsletterSubscription">
        {{ 'COMMON.LABEL.NEWSLETTER_SUBSCRIPTION' | translate}}
        <br>
        <span class="privacy-warning">
          {{ 'COMMON.LABEL.NEWSLETTER_PRIVACY_I_AGREE' | translate}}
        </span>
      </mat-checkbox>
    </div>
  </div>
</form>

<div class="row align-items-center justify-content-between"
  *ngIf="isMessageSent">
  <h3 class="col text-center my-3">
    {{ 'COMMON.LABEL.SUBSCRIBED_SUCCESSFULLY' | translate }}
  </h3>
</div>